export default {
    title: 'Profile',
    subtitle: 'Manage your personal information and preferences',
    tabs: {
        preferences: 'Preferences',
        account: 'Account',
        password: 'Password',
        picture: 'Profile Picture',
        companies: 'Companies',
        integrations: 'Integrations',
    },
    preferences: {
        language: {
            title: 'Language',
            description: 'Select your preferred language for the interface',
        },
        theme: {
            title: 'Theme',
            description: 'Choose between light and dark theme',
        },
    },
    account: {
        title: 'Account Information',
        description: 'Update your personal information',
        legalSection: {
            title: 'Legal',
            description: 'View our Terms & Conditions and Privacy Policy.',
        },
        firstName: 'First Name',
        firstNamePlaceholder: 'Enter your first name',
        lastName: 'Last Name',
        lastNamePlaceholder: 'Enter your last name',
        email: 'Email',
        emailPlaceholder: 'Enter your email address',
        phone: 'Phone',
        phonePlaceholder: 'Enter your phone number',
        jobTitle: 'Job Title',
        jobTitlePlaceholder: 'Enter your job title',
        department: 'Department',
        departmentPlaceholder: 'Enter your department',
    },
    password: {
        title: 'Change Password',
        description: 'Update your account password',
        currentPassword: 'Current Password',
        currentPasswordPlaceholder: 'Enter your current password',
        newPassword: 'New Password',
        newPasswordPlaceholder: 'Enter your new password',
        confirmPassword: 'Confirm Password',
        confirmPasswordPlaceholder: 'Confirm your new password',
        mismatch: 'Passwords do not match',
        changePassword: 'Change Password',
    },
    picture: {
        title: 'Profile Picture',
        description: 'Upload and manage your profile picture',
        global: 'Global (All Companies)',
        scope: 'Scope',
        scopeDescription: 'Choose whether this picture should be visible globally or only for a specific company',
        selectFile: 'Select File',
        upload: 'Upload',
        invalidFileType: 'Invalid file type. Please select a PNG, JPG, JPEG, or WEBP image.',
        fileTooLarge: 'File size exceeds 5MB limit.',
    },
    companies: {
        title: 'Companies',
        description: 'View all companies you are a member of',
        noCompanies: 'You are not a member of any companies',
        primary: 'Primary',
        noType: 'No Type',
        types: {
            sender: 'Sender',
            receiver: 'Receiver',
            freight_forwarder: 'Freight Forwarder',
            port_authority: 'Port Authority',
            carrier: 'Carrier',
            customs_broker: 'Customs Broker',
            insurance_provider: 'Insurance Provider',
        },
        role: {
            super_admin: 'Super Admin',
            company_admin: 'Company Admin',
            operator: 'Operator',
            viewer: 'Viewer',
        },
    },
    integrations: {
        title: 'Email Integrations',
        description: 'Connect your personal Gmail or Outlook accounts to Eve Mind',
        connectedAccounts: 'Connected Accounts',
        connectNew: 'Connect New Account',
        connectGmail: 'Connect Gmail',
        connectOutlook: 'Connect Outlook',
        confirmDisconnect: 'Are you sure you want to disconnect this email account?',
        providers: {
            gmail: 'Gmail',
            outlook: 'Outlook',
        },
        status: {
            active: 'Active',
            inactive: 'Inactive',
            error: 'Error',
            authentication_required: 'Authentication Required',
        },
        tracking: {
            title: 'Container Tracking',
            description: 'Configure automatic tracking updates for your shipments',
            autoRefresh: 'Automatic Updates',
            autoRefreshDescription: 'Enable automatic tracking status updates',
            dailyUpdates: 'Daily Updates',
            dailyUpdatesDescription: 'Number of tracking updates per day',
            updateTime: 'Update Time (UTC)',
            updateTimeDescription: 'Time when daily tracking update runs',
            saveSuccess: 'Tracking settings saved successfully',
            saveError: 'Failed to save tracking settings',
            loadError: 'Failed to load tracking settings',
        },
    },
};

